
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../vue-loader/lib/style-rewriter?id=data-v-0ee9ce4c!../../../vue-loader/lib/selector?type=styles&index=0!./TableFooter.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./TableFooter.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-0ee9ce4c!../../../vue-loader/lib/selector?type=template&index=0!./TableFooter.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/TableFooter.vue
// module id = 1216
// module chunks = 2